export default {"src":"/_next/static/media/fsm-symbol-dynamic-bg-50.73764a4d.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};